export const FAMILY_RELATIONSHIPS = [
  { label: "Father", value: "FATHER" },
  { label: "Mother", value: "MOTHER" },
  { label: "Brother", value: "BROTHER" },
  { label: "Sister", value: "SISTER" },
  { label: "Son", value: "SON" },
  { label: "Daughter", value: "DAUGHTER" },
  { label: "Husband", value: "HUSBAND" },
  { label: "Wife", value: "WIFE" },
  { label: "Uncle", value: "UNCLE" },
  { label: "Aunt", value: "AUNT" },
  { label: "Cousin", value: "COUSIN" },
  { label: "Niece", value: "NIECE" },
  { label: "Nephew", value: "NEPHEW" },
  { label: "Grand Daughter", value: "GRANDDAUGHTER" },
  { label: "Grand child", value: "GRANDCHILD" },
  { label: "Sibling", value: "SIBLING" },
  { label: "Spouse", value: "SPOUSE" },
  { label: "Grand parent", value: "GRANDPARENT" },
  { label: "Sibling in Law", value: "SIBLING_IN_LAW" },
  { label: "Mother in Law", value: "MOTHER_IN_LAW" },
  { label: "Father in Law", value: "FATHER_IN_LAW" },
  { label: "Son in Law", value: "SON_IN_LAW" },
  { label: "Daughter in Law", value: "DAUGHTER_IN_LAW" },
  { label: "Extended Family", value: "EXTENDED_FAMILY" },
  { label: "Close Friend", value: "CLOSE_FRIEND" },
  { label: "Family Friend", value: "FAMILY_FRIEND" },
];

export const PHONE_COUNTRIES = [
  { label: '+1', value: '+1', code: 'US' },
  { label: '+44', value: '+44', code: 'GB' },
  { label: '+61', value: '+61', code: 'AU' },
  { label: '+353', value: '+353', code: 'IE' },
  { label: '+91', value: '+91', code: 'IN' },
  { label: '+33', value: '+33', code: 'FR' },
  { label: '+49', value: '+49', code: 'DE' },
  { label: '+27', value: '+27', code: 'ZA' },
  { label: '+92', value: '+92', code: 'PK' },
  { label: '+86', value: '+86', code: 'CN' },
  { label: '+7', value: '+7', code: 'RU' },
  { label: '+39', value: '+39', code: 'IT' },
  { label: '+34', value: '+34', code: 'ES' },
  { label: '+1-246', value: '+1-246', code: 'BB' },
  { label: '+64', value: '+64', code: 'NZ' },
  { label: '+352', value: '+352', code: 'LU' },
  { label: '+370', value: '+370', code: 'LT' },
  { label: '+371', value: '+371', code: 'LV' },
  { label: '+372', value: '+372', code: 'EE' },
  { label: '+880', value: '+880', code: 'BD' },
];
